export default __webpack_public_path__ + "static/Landmark-Regular-02e2e9cc4f084e8f6807568b2d83eafe.woff";